<template>
  <hm-input v-model="internalValue"
            :id="$attrs['id']"
            :class="$attrs['class']"
            :label="label"
            :help="help"
            :has-focus="hasFocus"
            :is-empty="isValueEmpty"
            :name="name"
            :cols="cols"
            :disabled="disabledCombined"
            :validate="validate">
    <template slot="icon-inline-left" slot-scope="slot">
      <input-icon-button icon="search" @click="onClickSearch($event)" />
    </template>
  </hm-input>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';

export default {
  name: 'HmInputSearch',

  mixins: [HmInputMixin],

  methods: {
    onClickSearch: function (event) {
      this.$emit('onClickSearch', event);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .search {
    @include icon-color($mint);
    @include icon-hover($text);
    @include icon-input-hover($text);
    @include icon-input-focus($text);
  }
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputSearch.vue